import { render, staticRenderFns } from "./indirizzoedit.vue?vue&type=template&id=904b60a6"
import script from "./indirizzoedit.vue?vue&type=script&lang=js"
export * from "./indirizzoedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904b60a6')) {
      api.createRecord('904b60a6', component.options)
    } else {
      api.reload('904b60a6', component.options)
    }
    module.hot.accept("./indirizzoedit.vue?vue&type=template&id=904b60a6", function () {
      api.rerender('904b60a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/indirizzoedit.vue"
export default component.exports